import { call, put, takeLatest } from 'redux-saga/effects';
import { message } from 'antd';
import * as types from './types';
import * as actions from './actions';
import { cloudResourcesApi } from '../../containers/CloudResources/api/cloudResourcesApi';

// ── Fetch Attachments ───────────────────────────────────────────

function* fetchAttachmentsSaga(action) {
  try {
    const response = yield call(cloudResourcesApi.listAttachments, action.payload);
    yield put(actions.fetchAttachmentsSuccess(response.data));
  } catch (error) {
    const errorMsg = error.response?.data?.message || 'Failed to fetch attachments';
    yield put(actions.fetchAttachmentsFailure(errorMsg));
    message.error(errorMsg);
  }
}

// ── Create Attachment ───────────────────────────────────────────

function* createAttachmentSaga(action) {
  try {
    const { data, callback } = action.payload;
    const response = yield call(cloudResourcesApi.createAttachment, data);
    yield put(actions.createAttachmentSuccess(response.data));
    message.success('Policy attached successfully');

    if (callback) {
      callback(response.data);
    }
  } catch (error) {
    const errorMsg = error.response?.data?.message || 'Failed to attach policy';
    yield put(actions.createAttachmentFailure(errorMsg));
    message.error(errorMsg);
  }
}

// ── Bulk Attach ─────────────────────────────────────────────────

function* bulkAttachSaga(action) {
  try {
    const { data, callback } = action.payload;
    const response = yield call(cloudResourcesApi.bulkAttach, data);
    yield put(actions.bulkAttachSuccess(response.data));
    message.success(`Policy attached to ${response.data.total_created} accounts`);

    if (callback) {
      callback(response.data);
    }
  } catch (error) {
    const errorMsg = error.response?.data?.message || 'Failed to bulk attach policy';
    yield put(actions.bulkAttachFailure(errorMsg));
    message.error(errorMsg);
  }
}

// ── Detach Policy ───────────────────────────────────────────────

function* detachPolicySaga(action) {
  try {
    const { id, callback } = action.payload;
    yield call(cloudResourcesApi.detachPolicy, id);
    yield put(actions.detachPolicySuccess(id));
    message.success('Policy detached successfully');

    if (callback) {
      callback();
    }
  } catch (error) {
    const errorMsg = error.response?.data?.message || 'Failed to detach policy';
    yield put(actions.detachPolicyFailure(errorMsg));
    message.error(errorMsg);
  }
}

// ── Update Attachment ───────────────────────────────────────────

function* updateAttachmentSaga(action) {
  try {
    const { id, data, callback } = action.payload;
    const response = yield call(cloudResourcesApi.updateAttachment, id, data);
    yield put(actions.updateAttachmentSuccess(response.data));
    message.success('Attachment updated successfully');

    if (callback) {
      callback(response.data);
    }
  } catch (error) {
    const errorMsg = error.response?.data?.message || 'Failed to update attachment';
    yield put(actions.updateAttachmentFailure(errorMsg));
    message.error(errorMsg);
  }
}

// ── Fetch Sync Status ───────────────────────────────────────────

function* fetchSyncStatusSaga(action) {
  try {
    const response = yield call(cloudResourcesApi.listSyncStatus, action.payload);
    yield put(actions.fetchSyncStatusSuccess(response.data));
  } catch (error) {
    const errorMsg = error.response?.data?.message || 'Failed to fetch sync status';
    yield put(actions.fetchSyncStatusFailure(errorMsg));
    message.error(errorMsg);
  }
}

// ── Trigger Sync ────────────────────────────────────────────────

function* triggerSyncSaga(action) {
  try {
    const { orgId, callback } = action.payload;
    const response = yield call(cloudResourcesApi.triggerSync, orgId);
    yield put(actions.triggerSyncSuccess(response.data));
    message.success('Policy sync triggered successfully');

    if (callback) {
      callback(response.data);
    }
  } catch (error) {
    const errorMsg = error.response?.data?.message || 'Failed to trigger sync';
    yield put(actions.triggerSyncFailure(errorMsg));
    message.error(errorMsg);
  }
}

// ── Watcher Saga ────────────────────────────────────────────────

export default function* policyAttachmentsSaga() {
  yield takeLatest(types.FETCH_ATTACHMENTS_REQUEST, fetchAttachmentsSaga);
  yield takeLatest(types.CREATE_ATTACHMENT_REQUEST, createAttachmentSaga);
  yield takeLatest(types.BULK_ATTACH_REQUEST, bulkAttachSaga);
  yield takeLatest(types.DETACH_POLICY_REQUEST, detachPolicySaga);
  yield takeLatest(types.UPDATE_ATTACHMENT_REQUEST, updateAttachmentSaga);
  yield takeLatest(types.FETCH_SYNC_STATUS_REQUEST, fetchSyncStatusSaga);
  yield takeLatest(types.TRIGGER_SYNC_REQUEST, triggerSyncSaga);
}
